import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { useAuth } from '../../context/AuthContext';

export const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();
  const isLandingPage = location.pathname === '/';

  console.log('Navbar: Rendering with state - user:', !!user, 'isLandingPage:', isLandingPage, 'location:', location.pathname);

  if (location.pathname.startsWith('/app')) {
    return null; // Don't show navbar in /app routes
  }

  return (
    <div className="fixed top-4 left-0 right-0 z-50 px-4 md:px-8">
      <nav className="mx-auto max-w-7xl bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-gray-100/50">
        <div className="container mx-auto px-4 flex justify-between items-center h-16">
          <button 
            onClick={() => {
              if (isLandingPage) {
                document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' });
              } else {
                window.location.href = '/#hero';
              }
            }}
            className="text-xl md:text-2xl font-display font-bold gradient-text whitespace-nowrap overflow-hidden text-ellipsis bg-transparent border-none cursor-pointer"
          >
            Simplified Trading Journal
          </button>

          {/* Desktop - PRIMARY CTA + LOGIN */}
          <div className="hidden md:flex items-center space-x-3">
            {isLandingPage && (
              <>
                <Button 
                  as={Link} 
                  to="/login" 
                  variant="ghost"
                  className="!rounded-full px-6 py-2 text-gray-700 hover:text-gray-900 hover:bg-gray-50 transition-all duration-300"
                >
                  Login
                </Button>
                <Button 
                  as={Link} 
                  to="/trial" 
                  variant="primary" 
                  size="lg"
                  className="!rounded-full px-10 py-3 text-lg font-bold shadow-lg hover:shadow-xl bg-black hover:bg-gray-900 text-white transition-all duration-300"
                >
                  Start $0 Trial
                </Button>
              </>
            )}
          </div>

          {/* Mobile menu button */}
          <button 
            data-testid="mobile-menu"
            type="button"
            className="md:hidden text-gray-700"
            style={{ 
              padding: 16, 
              marginRight: -16,
              background: 'transparent', 
              border: 'none',
              outline: 'none'
            }}
            onClick={() => {
              console.log('Menu clicked!');
              setIsOpen(!isOpen);
            }}
          >
            {isOpen ? 
              <X size={28} style={{ pointerEvents: 'none' }} /> : 
              <Menu size={28} style={{ pointerEvents: 'none' }} />
            }
          </button>
        </div>

        {/* Mobile menu - CTA + LOGIN */}
        {isOpen && isLandingPage && (
          <div className="md:hidden bg-white border-t border-gray-100/50 px-4 py-4 rounded-b-2xl shadow-[0_10px_30px_-5px_rgba(0,0,0,0.1)]">
            <div className="flex flex-col space-y-4">
              <div className="text-center py-2">
                <p className="text-sm text-gray-600 mb-3">Join 100+ disciplined traders</p>
                <p className="text-xs text-gray-500 mb-4">No card needed • Cancel anytime</p>
                <Button 
                  as={Link} 
                  to="/trial"
                  variant="primary"
                  fullWidth
                  className="!rounded-full py-4 text-lg font-bold shadow-lg hover:shadow-xl bg-black hover:bg-gray-900 text-white transition-all duration-300 mb-3"
                  onClick={() => setIsOpen(false)}
                >
                  Start $0 Trial
                </Button>
                <Button 
                  as={Link} 
                  to="/login"
                  variant="ghost"
                  fullWidth
                  className="!rounded-full py-3 text-gray-700 hover:text-gray-900 hover:bg-gray-50 transition-all duration-300"
                  onClick={() => setIsOpen(false)}
                >
                  Login
                </Button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};